export const GET_ALL_DERMATOLOGIST = `query($first:Int,$last:Int,$after:Cursor,$before:Cursor,$filter: AbbvieLmbcHcpFilter){
    allAbbvieLmbcHcps(orderBy:CREATED_AT_DESC,first:$first,last:$last,after:$after,before:$before,filter:$filter){
		nodes{
			id
			firstName
			lastName
			email
			phone
			gender
			website
			language
			country
			imageId
			createdAt
			location
			address
			region
			clinicName
			monday
			tuesday
			wednesday
			thursday
			friday
			saturday
			sunday
		}
      	totalCount
            pageInfo {
			hasNextPage
			hasPreviousPage
			startCursor
			endCursor
        }
    }
}`;

export const CREATE_ABBVIE_LMBC_HCP = `mutation($lmbcHcp: AbbvieLmbcHcpInput!){
    insertAbbvieLmbcHcpMenual(input:{
      lmbcHcp: $lmbcHcp
    }){
      boolean
    }
}`;

export const UPDATE_LMBC_HCP = `mutation($lmbcHcp: AbbvieLmbcHcpInput!){
  editAbbvieLmbcHcp(input:{
    lmbcHcp: $lmbcHcp
  }){
    boolean
  }
}`;

export const DELETE_LMBC_HCP = `mutation($id: UUID!){
	deleteAbbvieLmbcHcpById(input:{
		id:$id
	})
    {
		abbvieLmbcHcp{
			id
		}
    }
}`;

export const CUSTOM_CREATE_ABBVIE_LMBC_HCP = `mutation($abbvieLmbcHcp:[AbbvieLmbcHcpInput]!, $insertType: String!, $countryList: [String]!){
    insertAbbvieLmbcHcp(input:{
      lmbcHcp:$abbvieLmbcHcp,
      insertType:$insertType
      countryList:$countryList
    })
    {
      boolean
    }
  }`;
